import React from 'react';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line, Image, Svg } from '@react-pdf/renderer';
import Angry from "../../../../assets/images/mood-rating/Angry.png";
import Bored from "../../../../assets/images/mood-rating/Bored.png";
import Calm from "../../../../assets/images/mood-rating/Calm.png";
import Confident from "../../../../assets/images/mood-rating/Confident.png";
import Excited from "../../../../assets/images/mood-rating/Excited.png";
import Happy from "../../../../assets/images/mood-rating/Happy.png";
import Hopeful from "../../../../assets/images/mood-rating/Hopeful.png";
import Nervous from "../../../../assets/images/mood-rating/Nervous.png";
import Proud from "../../../../assets/images/mood-rating/Proud.png";
import Relaxed from "../../../../assets/images/mood-rating/Relaxed.png";
import Sad from "../../../../assets/images/mood-rating/Sad.png";
import Scared from "../../../../assets/images/mood-rating/Scared.png";
import Tired from "../../../../assets/images/mood-rating/Tired.png";
import Worried from "../../../../assets/images/mood-rating/Worried.png";

const MoodImagePDF = ({ moodItem }) => {

  const styles = StyleSheet.create({
    image: {
      width: 30,
      height: 30,
      borderRadius: "50%"
    },
    Angry: {
      backgroundColor: "#e81224",
    },
    Bored: {
      backgroundColor: "#55bbd1",
    },
    Calm: {
      backgroundColor: "#55bbd1",
    },
    Confident: {
      backgroundColor: "#fff100",
    },
    Proud: {
      backgroundColor: "#fff100",
    },
    Excited: {
      backgroundColor: "#f7630c",
    },
    Happy: {
      backgroundColor: "#fff100",
    },
    Hopeful: {
      backgroundColor: "#fff100",
    },
    Nervous: {
      backgroundColor: "#16c60c",
    },
    Relaxed: {
      backgroundColor: "#55bbd1",
    },
    Sad: {
      backgroundColor: "#55bbd1",
    },
    Scared: {
      backgroundColor: "#f7630c",
    },
    Tired: {
      backgroundColor: "#55bbd1",
    },
    Worried: {
      backgroundColor: "#e81224",
    },
  })
  // Map mood ratings to corresponding images
  const moodImageMap = {
    Angry: Angry,
    Bored: Bored,
    Calm: Calm,
    Confident: Confident,
    Proud: Proud,
    Excited: Excited,
    Happy: Happy,
    Hopeful: Hopeful,
    Nervous: Nervous,
    Relaxed: Relaxed,
    Sad: Sad,
    Scared: Scared,
    Tired: Tired,
    Worried: Worried,
    // Add other mood ratings and their corresponding images here...
  };

  // Check if moodRating exists in the moodImageMap
  const selectedMoodImage = moodImageMap[moodItem?.moodRating];

  // Render the image if it exists, otherwise render a placeholder
  return (
    <>
    {/* styles[moodItem?.moodRating] */}
      <Image style={[styles.image]} src={selectedMoodImage} alt={moodItem?.moodRating} className={moodItem?.moodRating} />
    </>
  );
};

export default MoodImagePDF;
